// MessageThreadAffordance.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { formatChannelRelativeTime } from 'channels/utils/channelTime';

// CSS
import './MessageThreadAffordance.css';

const getReplyLabel = (count) => {
  const safeCount = Number(count) || 0;
  if (safeCount === 1) return '1 reply';
  return `${safeCount} replies`;
};

/**
 * MessageThreadAffordance
 *
 * Renders a compact thread summary row under a root message.
 *
 * @returns {ReactNode}
 */
const MessageThreadAffordance = React.memo(({
  replyCount = 0,
  lastReplyAt,
  hasUnreadReplies = false,
  onOpenThread,
}) => {

  // ----- CONTEXT ----- //

  const { theme } = useTheme();
  const safeCount = Number(replyCount) || 0;

  if (safeCount <= 0) return null;

  const lastReplyLabel = formatChannelRelativeTime(lastReplyAt);
  const summary = lastReplyLabel
    ? `${getReplyLabel(safeCount)} · Last reply ${lastReplyLabel}`
    : getReplyLabel(safeCount);

  // ----- RENDER ----- //

  return (
    <button
      className={`message-thread-affordance${hasUnreadReplies ? ' is-unread' : ''}`}
      style={{
        color: hasUnreadReplies ? theme.foreground : theme.foregroundMuted,
      }}
      type="button"
      onClick={onOpenThread}
    >

      {/* DOT */}
      {hasUnreadReplies ? (
        <span
          className="message-thread-affordance-dot"
          aria-hidden
        />
      ) : null}
      <span>{summary}</span>
    </button>
  );
});

// Dev Tools
MessageThreadAffordance.displayName = 'MessageThreadAffordance';

export default MessageThreadAffordance;
